<template>
    <div class="modal trip-destination-modal" tabindex="-1" id="trip-destination-modal">
        <div class="modal-dialog" v-if="destination">
            <div class="modal-content">
                <!-- Close button -->
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fa fa-times"></i>
                </button>

                <img :src="destination.image + '?width=500&height=300'" :srcset="destination.image + '?width=500&height=300 1x, ' + destination.image + '?width=1000&height=600 2x'" class="modal-image" v-if="destination.image" />

                <div class="modal-header">
                    <h3 v-if="destination.name">
                        {{ destination.name }}
                    </h3>

                    <p class="lead" v-if="destination.description">
                        {{ destination.description }}
                    </p>
                </div>

                <div class="modal-body">
                    <!-- Articles -->
                    <div v-if="destination.articles && destination.articles.length > 0">
                        <span class="section-title">
                            Reisemagazin
                        </span>
                        <small class="d-block text-muted">
                            Interessante Artikel aus unserem Reisemagazin passend zu diesem Ort.
                        </small>
                        <div class="list-group list-group-flush mx-n3">
                            <a class="list-group-item list-group-item-action d-flex align-items-center px-3 rounded" v-for="article in destination.articles" :href="article.url" target="_blank">
                                <img :src="article.image + '?width=100&height=80'" class="rounded img-fluid mr-3" style="width: 100px;" v-if="article.image" />

                                <div class="flex-grow-1 mr-3">
                                    <strong class="d-block text-dark">
                                        {{ article.title }}
                                    </strong>

                                    <small class="d-block text-dark">
                                        {{ article.subtitle }}
                                    </small>
                                </div>

                                <i class="wa-icon-long-arrow-right text-primary mt-2"></i>
                            </a>
                        </div>
                    </div>

                    <div class="divider" v-if="destination.articles && destination.articles.length > 0 && destination.hotels && destination.hotels.length > 0"></div>

                    <!-- List hotels -->
                    <div v-if="destination.hotels && destination.hotels.length > 0">
                        <span class="section-title">
                            Hotels
                        </span>
                        <div class="list-group list-group-flush mx-n3">
                            <button type="button" class="list-group-item list-group-item-action px-3 rounded" v-for="hotel in destination.hotels" @click="showHotelDetails(hotel)">
                                <div class="d-flex align-items-center">
                                    <img :src="$cdn.default + 'hotels/' + hotel.guid + '/' + hotel.image + '?width=100&height=80'" class="rounded img-fluid mr-3" style="width: 100px;" v-if="hotel.image" />

                                    <div class="flex-grow-1 mr-3">
                                        <strong class="d-block text-dark">
                                            {{ hotel.name }}

                                            <i class="fa fa-star text-warning" v-for="index in hotel.stars" :key="index"></i>
                                        </strong>

                                        <small class="text-dark d-block">
                                            {{ hotel.address }}
                                        </small>
                                    </div>

                                    <i class="far fa-info-circle mr-2" v-if="hotelDetailsAvailable(hotel)"></i>
                                </div>
                            </button>
                        </div>
                    </div>

                    <!-- Close button -->
                    <button type="button" class="btn btn-link btn-block mt-3" data-dismiss="modal">
                        Fenster schließen
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data() {
            return {
                destination: null,
            }
        },
        mounted() {},
        computed: {},
        methods: {
            setDestination(destination) {
                this.destination = destination

                $('div#trip-destination-modal').modal('show')
            },
            hotelDetailsAvailable(hotel) {
                return $('div#accommodation-details-' + hotel.id).length > 0
            },
            showHotelDetails(hotel) {
                $('div#accommodation-details-' + hotel.id).modal('show')
            }
        },
        watch: {}
    }
</script>
